import React from 'react';
import { MenuItemProps } from '@mui/material';
import { CustomIcon } from 'components/CustomIcon';
import * as Styled from './MBMenuItem.styles';

interface ItemProps extends MenuItemProps {
  isSelected?: boolean;
  withIcon?: boolean;
}

const MBMenuItem: React.FC<ItemProps> = ({
  isSelected = false,
  withIcon = true,
  children,
  ...rest
}) => {
  return (
    <Styled.MenuItem {...rest}>
      {withIcon && (
        <Styled.MenuIconContainer>
          {isSelected && <CustomIcon name="tick" dense />}
        </Styled.MenuIconContainer>
      )}

      {children}
    </Styled.MenuItem>
  );
};

export default MBMenuItem;
